import React from 'react';
import * as formTypes from 'constants/formTypes';
import i18n from 'util/i18n';
import { rootSelectors } from '@redux/modules/selectors';
import { useSelector } from 'react-redux';
import { RootState } from 'types/state';
import { DateTime } from 'luxon';
import './Instructions.scss';
import classNames from 'classnames';
import useWindowSize from '../../hooks/useWindowSize';

interface Props {
  isModal?: boolean
}

const Instructions: React.FC<Props> = function ({ isModal = false }) {
  const windowScreenSize = useWindowSize();
  const formType = useSelector((state: RootState) => rootSelectors.application.getFormType(state));
  const formVersion = useSelector((state: RootState) => rootSelectors.application.getFormVersion(state));
  const lastLogin = useSelector((state: RootState) => rootSelectors.authentication.getLastLogin(state));
  const logintimestamp = lastLogin
    ? DateTime.fromISO(lastLogin).toFormat('yyyy LLL dd HH:mm')
    : 'Never';

  let introductionHeading = i18n.m('introduction.heading', { logintimestamp });
  let introductionContent = i18n.m('introduction.contents');

  switch (formType) {
    case formTypes.SF85: {
      introductionHeading = i18n.m('introduction.heading85', { logintimestamp });
      if (formVersion === '2021-11') {
        introductionContent = i18n.m('introduction.contents852021');
      } else if (formVersion === '2024-02') {
        introductionContent = i18n.m('introduction.contents852024');
      } else {
        introductionContent = i18n.m('introduction.contents85');
      }
      break;
    }
    case formTypes.SF852013: {
      introductionHeading = i18n.m('introduction.heading85', { logintimestamp });
      introductionContent = i18n.m('introduction.contents852013');
      break;
    }
    case formTypes.SF85P: {
      if (formVersion === '2021-01') {
        introductionHeading = i18n.m('introduction.heading85p', { logintimestamp });
        introductionContent = i18n.m('introduction.contents85p2021');
      } else if (formVersion === '2024-02') {
        introductionHeading = i18n.m('introduction.heading85p', { logintimestamp });
        introductionContent = i18n.m('introduction.contents85p2024');
      } else {
        introductionHeading = i18n.m('introduction.heading85p', { logintimestamp });
        introductionContent = i18n.m('introduction.contents85p');
      }
      break;
    }
    case formTypes.SF85PS: {
      if (formVersion === '2024-02') {
        introductionHeading = i18n.m('introduction.heading85ps', { logintimestamp });
        introductionContent = i18n.m('introduction.contents85ps2024');
      } else {
        introductionHeading = i18n.m('introduction.heading85ps', { logintimestamp });
        introductionContent = i18n.m('introduction.contents85ps');
      }
      break;
    }
    case formTypes.PVQ_A:
    case formTypes.PVQ_A_B:
    case formTypes.PVQ_A_B_C:
    case formTypes.PVQ_A_B_D: {
      introductionHeading = i18n.m('introduction.heading', { logintimestamp });
      introductionContent = i18n.m('introduction.contentsPvq');
      break;
    }
    default: { // SF86
      if (formVersion === '2020-02') {
        introductionHeading = i18n.m('introduction.heading', { logintimestamp });
        introductionContent = i18n.m('introduction.contentsSF862020');
      } else if (formVersion === '2024-02') {
        introductionHeading = i18n.m('introduction.heading', { logintimestamp });
        introductionContent = i18n.m('introduction.contentsSF862024');
      } else {
        introductionHeading = i18n.m('introduction.heading', { logintimestamp });
        introductionContent = i18n.m('introduction.contents');
      }
    }
  }

  const headerClass = classNames(
    { 'instructions-header-none': windowScreenSize === 'sm' },
    { 'instructions-header-md': windowScreenSize === 'md' },
    { 'instructions-header-lg': windowScreenSize === 'lg' || windowScreenSize === 'xl' }
  );

  const instructionsBackgroundClass = classNames(
    'instructions-content',
    {
      'instructions-content-background-white':
        windowScreenSize === 'sm' || windowScreenSize === 'md',
    },
    { 'instructions-content-background': windowScreenSize === 'lg' || windowScreenSize === 'xl' }
  );

  const instructionsContentClass = classNames(
    { 'instructions-content-sm': windowScreenSize === 'sm' },
    { 'instructions-content-md': windowScreenSize === 'md' },
    { 'instructions-content-md': windowScreenSize === 'lg' },
    { 'instructions-content-lg': windowScreenSize === 'xl' }
  );

  if (isModal === true) {
    return (
      <div>
        {introductionHeading}
        {introductionContent}
      </div>
    );
  }

  return (
    <div className="token-error login eapp-core" id="login">
      <div id="seal-header" className="seal-header">
        <img src="/img/dcsa-logo.png" alt="National Background Investigation Services" />
        <h3 className={headerClass}>{i18n.t('login.token.heading')}</h3>
      </div>
      <div className={instructionsBackgroundClass}>
        <div className={instructionsContentClass}>
          <div className="table one">{introductionContent}</div>
        </div>
      </div>
    </div>
  );
};

export default Instructions;
